import {
  PROJ_MEAL_BREAK_ID,
  PROJ_UNPAID_TIME_OFF_ID,
  TASKTYPE_MEAL_BREAK_ID,
} from "../../SharedModule/utils/constants";
import { EntryListView, TimeEntryForm } from "../types/times-module-types";
import {
  getDateFromDateString,
  isSameDay,
} from "../../SharedModule/utils/dateUtils";

// Every 15-minute slot in a 24h day, labeled 12-hour "hh:mm am/pm" (e.g.
// "12:00 am" .. "11:45 pm"). Index order matters - entryHoursBoxValidation.ts
// and EntryHoursBox.tsx look up entries by fixed index (e.g. [48] for noon)
// and compare objects by reference via mealBreakHours.indexOf(selectedValue).
export const mealBreakHours = Array.from({ length: 96 }, (_, index) => {
  const totalMinutes = index * 15;
  const hour24 = Math.floor(totalMinutes / 60);
  const minute = totalMinutes % 60;
  const period = hour24 < 12 ? "am" : "pm";
  const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
  const label = `${String(hour12).padStart(2, "0")}:${String(minute).padStart(
    2,
    "0"
  )} ${period}`;
  return { value: label, label };
});

export const getIndexFromMealBreakHours = (
  entryDescription: string,
  start: boolean
) => {
  let mealBreakFromDescription = {
    value: start
      ? entryDescription.split(" ")[0] + " " + entryDescription.split(" ")[1]
      : entryDescription.split(" ")[3] + " " + entryDescription.split(" ")[4],
    label: start
      ? entryDescription.split(" ")[0] + " " + entryDescription.split(" ")[1]
      : entryDescription.split(" ")[3] + " " + entryDescription.split(" ")[4],
  };

  return mealBreakHours.findIndex(
    (elem) => mealBreakFromDescription.value === elem.value
  );
};

export const alreadyExistMealBreak = (
  entry: TimeEntryForm,
  timeEntriesList: EntryListView[]
) => {
  // check is actual entry is not meal break
  if (entry.entryProjectWorkOrder.value !== PROJ_MEAL_BREAK_ID) {
    if (
      entry.entryProjectWorkOrder.value !== PROJ_UNPAID_TIME_OFF_ID ||
      (entry.entryProjectWorkOrder.value === PROJ_UNPAID_TIME_OFF_ID &&
        entry.entryTaskType.value !== TASKTYPE_MEAL_BREAK_ID)
    ) {
      return false;
    }
  }
  let response: any = timeEntriesList
    .filter(
      (elem) =>
        elem.entityId === PROJ_MEAL_BREAK_ID ||
        (elem.entityId === PROJ_UNPAID_TIME_OFF_ID &&
          elem.taskTypeId === TASKTYPE_MEAL_BREAK_ID)
    )
    .find((elem) =>
      isSameDay(elem.entryDate, getDateFromDateString(entry.entryDate))
    );
  return !!response;
};

export const generateWeekHeaders = (startDate) => {
  const daysOfWeek = [
    "SUN",
    "MON",
    "TUE",
    "WED",
    "THU",
    "FRI",
    "SAT",
    "SUN",
    "MON",
    "TUE",
    "WED",
    "THU",
    "FRI",
    "SAT",
  ];
  const headers: any = [];

  for (let i = 0; i < 14; i++) {
    const currentDate = new Date(startDate);
    currentDate.setDate(currentDate.getDate() + i);

    const dayName = daysOfWeek[currentDate.getDay()];
    const formattedDate = `${
      currentDate.getMonth() + 1
    }/${currentDate.getDate()}`;

    headers.push(
      <th
        className="border-left border-right border-top fw-500 py-3 px-2 column-6"
        key={formattedDate}
      >
        <div className="d-flex flex-column">
          <span className="text-center">{dayName}</span>
          <span className="text-center">{formattedDate}</span>
        </div>
      </th>
    );
  }
  return headers;
};

export const checkDayWeekend = (index: number) => {
  return [0, 6, 7, 13].includes(index);
};

export const missingMealBreakTime = (mealBreakUserList, elem) => {
  return mealBreakUserList[elem].some((day) => day.missingTime)
    ? "cell-meal-break-error"
    : "cell-meal-break";
};
